<template>
    <div>
        <template v-if="type == 'bar'">
                <BarChart :chartData="chartDataCopy" :chartOptions="chartOptions" @chart-canvas="handleChartCanvas"/>  
        </template>

        <template v-else-if="type == 'line'">
                <LineChart :chartData="chartDataCopy" :chartOptions="chartOptions" @chart-canvas="handleChartCanvas"/>
        </template>

        <template v-else-if="type == 'doughnut'">
                <DoughnutChart :chartData="chartDataCopy" :chartOptions="chartOptions" @chart-canvas="handleChartCanvas"/>
        </template>

        <template v-else-if="type == 'pie'">
                <PieChart :chartData="chartDataCopy" :chartOptions="chartOptions" @chart-canvas="handleChartCanvas"/>
        </template>

        <template v-else-if="type == 'radar'">
            <RadarChart :chartData="chartDataCopy" :chartOptions="chartOptions" @chart-canvas="handleChartCanvas"/>
        </template>

        <template v-else-if="type == 'bubble'">
            <BubbleChart :chartData="chartDataCopy" :chartOptions="chartOptions" @chart-canvas="handleChartCanvas"/>
        </template>

        <template v-else-if="type == 'scatter'">
            <ScatterChart :chartData="chartDataCopy" :chartOptions="chartOptions" @chart-canvas="handleChartCanvas"/>
        </template>

        <template v-else-if="type == 'horizontalBar'">
            <HorizontalBarChart :chartData="chartDataCopy" :chartOptions="chartOptions" @chart-canvas="handleChartCanvas"/>
        </template>

        <md-card-actions>
            <md-menu md-size="medium" md-direction="bottom-end">
                <md-button class="md-icon-button" md-menu-trigger>
                    <md-icon>file_download</md-icon>
                </md-button>
                <md-menu-content>
                    <md-menu-item v-on:click="saveChartCsv">
                        <span>.csv</span>
                        <md-icon>file_download</md-icon>
                    </md-menu-item>
                    <md-menu-item v-on:click="saveChart">
                        <span>.png</span>
                        <md-icon>image</md-icon>
                    </md-menu-item>
                </md-menu-content>
            </md-menu>
        </md-card-actions>
    </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import BarChart from './Charts/BarChart.js';
import DoughnutChart from './Charts/DoughnutChart.js';
import LineChart from './Charts/LineChart.js';
import PieChart from './Charts/PieChart.js';
import RadarChart from './Charts/RadarChart.js';
import BubbleChart from './Charts/BubbleChart.js';
import ScatterChart from './Charts/ScatterChart.js';
import HorizontalBarChart from './Charts/HorizontalBarChart.js';
import secondaryColors from '@/constants/secondaryColors.js';
//import Chart from 'chart.js';

export default {
    name: "ChartContainer",
    props: {
        type: {
            type: String,
            required: true
        },
        chartData: {
            type: Object,
            default: null
        },
        chartOptions: {
            type: Object,
            default: null
        }
    },
    data: () => ({
        canvas: null,
        chartDataCopy: null
    }),
    components: {
        BarChart,
        DoughnutChart,
        LineChart,
        PieChart,
        RadarChart,
        BubbleChart,
        ScatterChart,
        HorizontalBarChart
    },
    beforeMount: function() {
        this.copyData();
        this.roundValues();
        this.setColours();
        //this.setChartAreaBackgroundColor();
    },
    methods: {
        copyData: function() {
            this.chartDataCopy = JSON.parse(JSON.stringify(this.chartData));
        },
        roundValues: function() {
            this.chartDataCopy.labels.forEach((label, index, labels) => {
                if(!isNaN(label) && typeof label !== 'string'){
                    labels[index] = label.toFixed(3);
                }
            })
        },
        setColours: function() {
            var colours = [];
            // if the number of datasets is > than the number of colours in the colours list,
            // generate colours list which repeats itself up until the number of datasets
            function fillColoursArray(noReq){
                let remainder = noReq % colours.length;
                let noFullArrays = Math.floor(noReq/colours.length);
                let newColours = Array(noFullArrays).fill(colours);
                let remainderColours = colours.slice(0, remainder);
                newColours.push(remainderColours);
                return(newColours.flat())
            }

            for (var key in secondaryColors) {
                colours.push(secondaryColors[key])
            }

            if (this.type == 'doughnut' || this.type =='pie'){
                let noLabels = this.chartDataCopy.labels.length;

                if(noLabels > colours.length) {
                    colours = fillColoursArray(noLabels);
                }

                this.chartDataCopy.datasets.forEach((dataset) => {
                    dataset.backgroundColor = [];
                    dataset.borderColor = [];
                    for (let i =0; i < noLabels; i++){
                        dataset.backgroundColor.push(colours[i] + "CC"); // 80% alpha channel 
                        dataset.borderColor.push(colours[i]);
                    }
                })
            } else {
                let noDatasets = this.chartDataCopy.datasets.length

                if(noDatasets > colours.length){
                    colours = fillColoursArray(noDatasets)
                }
                this.chartDataCopy.datasets.forEach((dataset, index) => {
                    dataset.backgroundColor = colours[index]+ "CC"; // 80% alpha channel 
                    dataset.borderColor = colours[index];
                })
            }
        },
        handleChartCanvas: function (event) {
            this.canvas = event;
        },
        saveChart: function () {
            let png = this.canvas.toDataURL('image/png');
            let filename = this.chartOptions.title.display ? this.chartOptions.title.text+".png" : "chart.png";
            let element = document.createElement('a');

            element.setAttribute('download', filename);
            element.setAttribute('href', png);
            element.style.display = 'none';

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        },
        saveChartCsv: function() {
            this.$emit('save-csv');
        },
        /* 
        // code for setting the background colour of the chart so that when we download the png isn't transparent
        // only affects chart area so currently removed
        setChartAreaBackgroundColor: function() {
            Chart.pluginService.register({
                beforeDraw: function (chart) {
                    if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
                        var ctx = chart.chart.ctx;
                        var chartArea = chart.chartArea;

                        ctx.save();
                        ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
                        ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
                        ctx.restore();
                    }
                }
            }); 
        }
        */
    },

}
</script>